
import 'echarts/lib/chart/pie'

const getPieChart = (data, color) => {
  const defaultConfig = {
    backgroundColor: '#fff',
    tooltip: {
      show: true
    },
    color: color,
    series: [
      {
        type: 'pie',
        radius: ['68%', '90%'],
        center: ['50%', '50%'],
        hoverAnimation: true,
        z: 10,
        itemStyle: {
          normal: {
            borderWidth: 4,
            borderColor: '#fff'
          }
        },
        label: {
          show: false
        },
        data: data,
        labelLine: {
          show: false
        }
      }
    ]
  }

  const opt = Object.assign({}, defaultConfig)
  const { grid, tooltip, xAxis, yAxis, title, series } = opt
  const chartOpt = {
    color,
    grid,
    tooltip,
    xAxis,
    yAxis,
    title,
    series
  }
  return chartOpt
}
const getPieChart2 = (data, color, total, text) => {
  const defaultConfig = {
    // tooltip: {
    //   formatter: '{b} : {d}%'
    // },
    grid: {
      top: "0%",
      left: "0%",
      right: "0%",
      bottom: "0%",
      containLabel: false
    },
    title: [
      {
          text: text,
          x: 'center',
          top: '42%',
          textStyle: {
              color: '#677392',
              fontSize: 12,
              fontWeight: 200,
          },
      },
      {
          text: total+'%',
          x: 'center',
          top: '38%',
          textStyle: {
              fontSize: 12,
              color: '#262626',
              fontWeight: '200',
          },
      },
    ],
    color: color,
    series: [
        {
            label:{
                show:false,
            },
            hoverAnimation:false,
            name: '面积模式',
            type: 'pie',
            radius: [20, 140],
            itemStyle: {
               
                shadowBlur: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
            },
            center: ['50%', '50%'],
            radius:['85%','100%'],
            data:data
        }
    ]
  }
  const opt = Object.assign({}, defaultConfig)
  const {  tooltip,  title, series } = opt
  const chartOpt = {
    color,
    tooltip,
    title,
    series
  }
  return chartOpt
}
const getPieChartCountry = (data,total) => {
  const option = {
    tooltip: {
        formatter: '{b} : {d}%'
    },
title: [
    {
        text: 'Followers',
        x: 'center',
        top: '42%',
        textStyle: {
            color: '#677392',
            fontSize: 12,
            fontWeight: '100',
        },
    },
    {
        text: total,
        x: 'center',
        top: '50%',
        textStyle: {
            fontSize: 16,
            color: '#2D3446',
            foontWeight: '500',
        },
    },
],
    series: [
        {
            label:{
                show:false,
            },
            name: '面积模式',
            type: 'pie',
            radius: [20, 140],
            itemStyle: {
                normal: {
                    color: function(colors) {
                        var colorList =[
                          "#E98D26",
                          "#7F5CFF",
                          "#6FC87B",
                          "#4278FF",
                          "#FBBC00",
                          "#3CCFDC",
                          "#E96469",
                          "#83A7FF",
                          "#EE888C",
                          "#175858",
                          "#886bd8",
                          "#65c06d",
                          "#307379",
                          "#7a4d4e",
                          "#566385",
                          "#521d1e",
                          "#175858",
                          "#9385bb",
                          "#12721a",
                        
                        ]
                        return colorList[colors.dataIndex]
                    }
                },
                shadowBlur: 200,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
            },

            center: ['50%', '50%'],
            radius:['70%','85%'],
            data:data
        }
    ]
};
  const opt = Object.assign({}, option)
  const {  tooltip,  title, series } = opt
  const chartOpt = {
    tooltip,
    title,
    series
  }
  return chartOpt
}

const getPieChartSex = (obj) => {

  const option = {
    tooltip: {
        formatter: '{b} : {d}%'
    },
    grid: {
      top: "0%",
      left: "0%",
      right: "0%",
      bottom: "0%",
      containLabel: false
    },
    series: [
        {
            label:{
                show:false,
            },
            name: '面积模式',
            type: 'pie',
            radius: [20, 140],
            itemStyle: {
                normal: {
                    color: function(colors) {
                        var colorList = [
                          "#E98D26",
                          "#7F5CFF",
                          "#6FC87B",
                          "#4278FF",
                          "#FBBC00",
                          "#3CCFDC",
                          "#E96469"
                        ];
                        return colorList[colors.dataIndex]
                    }},
                            shadowBlur: 200,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
            },
                    
            center: ['50%', '50%'],
            radius:['70%','85%'],
  
            data: obj.ageDatas
        },
        {
            label:{
                show:false,
            },
            itemStyle: {
                normal: {
                    color: function(colors) {
                        var colorList = ["#83A7FF", "#EE888C"];
                        return colorList[colors.dataIndex]
                    }},
                            shadowBlur: 200,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
            },
            name: '面积模式2',
            type: 'pie',
            radius: [20, 140],
            center: ['50%', '50%'],
            radius:['0%','50%'],
            data:obj.sexDatas
        }
    ]
};
  const opt = Object.assign({}, option)
  const {  tooltip,  title, series } = opt
  const chartOpt = {
    tooltip,
    title,
    series
  }
  return chartOpt
}
export default { getPieChart ,getPieChart2,getPieChartSex,getPieChartCountry}



// WEBPACK FOOTER //
// ./src/components/chart/options/pie/index.js